import React, { forwardRef } from "react";
import Section from "./Section/Section";
import SectionHeader from "./Section/SectionHeader";

const Contact = forwardRef((props, ref) => {
  const submitHandler = (e) => e.preventDefault();
  return (
    <Section id="contactus" ref={ref}>
      <SectionHeader
        noBg
        half
        title={"Contact"}
        content={"Lorem ipsum dolor sit amet, consectetur adipisicing elit."}
      />
      <form
        onSubmit={submitHandler}
        className="col-span-1 lg:col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-8"
      >
        <input
          className="col-span-2 lg:col-span-1 rounded border border-slate-400"
          type="text"
          placeholder="name"
        />
        <input
          className="col-span-2 lg:col-span-1 rounded border border-slate-400"
          type="email"
          placeholder="email"
        />
        <textarea
          className="col-span-2 rounded border border-slate-400"
          placeholder="Message"
        />
        <button
          className="bg-indigo-900 w-fit ml-auto col-span-2 px-4 py-3 text-yellow-500 rounded-lg font-bold activeButton"
          type="submit"
        >
          Send Message
        </button>
      </form>
    </Section>
  );
});

export default Contact;
